import { Component,ViewChild, enableProdMode } from '@angular/core';
import { Platform, Nav, Events} from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { Http,Headers,RequestOptions } from '@angular/http';

import { LoginPage } from '../pages/login/login';
import { RegisterRequestPage } from '../pages/register-request/register-request';
import { SettingsPage } from '../pages/settings/settings';
import { MessagecenterPage } from '../pages/messagecenter/messagecenter';
import { UserInfoPage } from '../pages/user-info/user-info';

import { PhonebookPage } from '../pages/phonebook/phonebook';
import { DashboardPage } from '../pages/dashboard/dashboard';
import { GuestdashboardPage } from '../pages/guestdashboard/guestdashboard';
import { IdeapoolPage } from '../pages/ideapool/ideapool';
import { WorkplanPage } from '../pages/workplan/workplan';
import { NewsPage } from '../pages/news/news';
import { VacationPage } from '../pages/vacation/vacation';
import { JobsPage } from '../pages/jobs/jobs';
import { MagazinePage } from '../pages/magazine/magazine';
import { MagazineLandingPage } from '../pages/magazine-landing/magazine-landing';
import { ContactPage } from '../pages/contact/contact';
import { EventsPage } from '../pages/events/events';
import { IdcardPage } from '../pages/idcard/idcard';
import { MarketplacePage } from '../pages/marketplace/marketplace';
import { BrowserPage } from '../pages/browser/browser';
import { WallPage } from '../pages/wall/wall';
import { SickcertificatePage } from '../pages/sickcertificate/sickcertificate';
import { FilesPage } from '../pages/files/files';
import { ChatPage } from '../pages/chat/chat';
import { WebfleetReportOverviewPage } from '../pages/webfleet-report-overview/webfleet-report-overview';
import {WebfleetReportListPage} from "../pages/webfleet-report-list/webfleet-report-list";
import { UserProvider } from '../providers/user';
import { LogoutProvider } from '../providers/logout';
import { MessageProvider } from '../providers/message';

import { Settings } from '../settings';

enableProdMode();

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;

  rootPage = LoginPage;

  basicPages: any;
  modulePages: any;
  contentPages: any;
  footerPages: any = [];

  guestPages: any;
  guestPagesLegal: any;

  memberPages: any;


  unreadMessagesCount: number = 0;

  constructor(private splashscreen: SplashScreen, private http: Http, platform: Platform, statusBar: StatusBar, public userProvider: UserProvider, public events: Events, public logoutProvider: LogoutProvider, public messageProvider: MessageProvider) {

    this.splashscreen.hide();
    //Mitarbeiter Pages - employee
    this.basicPages = [
        { icon: 'home', title: 'Home', component: 'dashboard' },
    ];

    this.modulePages = [

        { icon: 'chatbubbles', title: 'Chats', component: 'chat' },
        { icon: 'briefcase', title: 'Wochenplan', component: 'workplan' },
        { icon: 'sunny', title: 'Urlaubsanträge', component: 'vacation', page: null },
        { icon: 'document', title: 'Formulare', component: 'magazine' , page: 16},
        { icon: 'book', title: 'Telefonbuch', component: 'phonebook', page: null},
        { icon: 'bulb', title: 'Ideen & Verbesserungen', component: 'ideapool', page: null },
        { icon: 'mail', title: 'Kontakt', component: 'contact', page: null },
        //{ icon: 'map', title: 'Projekte', component: LoginPage },



        //{ icon: 'calendar', title: 'Termine', component: LoginPage },
        //{ icon: 'basket', title: 'Schwarzes Brett', component: LoginPage },



    ];

    this.contentPages = [
        { icon: 'paper', title: 'News', component: 'news', page: null },
        { icon: 'build', title: 'Jobs', component: 'jobs', page: null},
        { icon: 'happy', title: 'Unsere Philosophie', component: 'magazine' , page: 19 },


        { icon: 'document', title: 'Magazin', component: 'magazine_landing', cat_id: 'all'},
        { icon: 'calendar', title: 'Events', component: 'events', page: null},
    ];

    //Benutzer Pages - user
    this.memberPages = [
      { icon: 'medical', title: 'Soziale Verantwortung', component: 'magazine' , page: 7},
      { icon: 'document', title: 'Arbeitssicherheit', component: 'magazine' , page: 6},
    ];

    //Gast Pages - guests
    this.guestPages = [
        { icon: 'home', title: 'Home', component: 'guest_dashboard', page: null },
		{ icon: 'document', title: 'Magazin', component: 'magazine_landing', cat_id: 'all'},
        { icon: 'build', title: 'Jobs', component: 'jobs', page: null},

    ];

    this.guestPagesLegal = [
        { icon: 'lock', title: 'Datenschutz', component: 'magazine', page: Settings.privacyPolicyPage},
        { icon: 'information-circle', title: 'Impressum', component: 'magazine', page: Settings.legalPage},
    ];


    platform.ready().then(() => {
      statusBar.styleDefault();
      this.splashscreen.hide();
      this.loadMenuFromServer();

      this.messageProvider.startSubscribe();
      this.unreadMessagesCount = this.messageProvider.getChatMessageCount();
    });

    events.subscribe('usermenu:action', (click) => {
        this.userMenuAction(click);
    });

    events.subscribe('workplan:user', (user) => {
        this.nav.push(WorkplanPage, {user_payload: user});
    });

    events.subscribe('app:changepage', (component_module, component_title, component_page) => {
        this.openPage({
            component: component_module,
            title: component_title,
            page: component_page,
            cat_id: component_page,
        });
    });


  }

  openPage(page: any) {
    if(page.component == 'dashboard') {
        this.nav.setRoot(DashboardPage);
    }
    else if(page.component == 'guest_dashboard') {
        this.nav.setRoot(GuestdashboardPage);
    }
    else if(page.component == 'magazine') {
        this.nav.push(MagazinePage,{page: page.page, title: page.title});
    }
    else if(page.component == 'magazine_landing') {
        this.nav.push(MagazineLandingPage,{cat_id: page.cat_id, title: page.title});
    }

    else if(page.component == 'jobs') {
        this.nav.push(JobsPage,{title: page.title});
    }
    else if(page.component == 'events') {
        this.nav.push(EventsPage, {title: page.title});
    }
    else if(page.component == 'news') {
        this.nav.push(NewsPage, {title: page.title});
    }
    else if(page.component == 'ideapool') {
        this.nav.push(IdeapoolPage, {title: page.title});
    }
    else if(page.component == 'workplan') {
        this.nav.push(WorkplanPage, {title: page.title});
    }
    else if(page.component == 'phonebook') {
        this.nav.push(PhonebookPage, {title: page.title});
    }
    else if(page.component == 'vacation') {
        this.nav.push(VacationPage, {title: page.title});
    }
    else if(page.component == 'contact') {
        this.nav.push(ContactPage, {title: page.title});
    }
    else if(page.component == 'idcard') {
        this.nav.push(IdcardPage, {title: page.title});
    }
    else if(page.component == 'marketplace') {
        this.nav.push(MarketplacePage, {title: page.title});
    }
    else if(page.component == 'sickcertificate') {
        this.nav.push(SickcertificatePage, {title: page.title});
    }
    else if(page.component == 'browser') {
        let urlString: string = page.page.replace('%user_id%',this.userProvider.getUserID());
        let hideNav = 'yes';
        if(page.cat_id == 1) {
            hideNav = 'no';
        } else {
            hideNav = 'yes';
        }
        this.nav.push(BrowserPage, {title: page.title, url: urlString, hide_nav: hideNav});
    }
    else if(page.component == 'messages') {
        this.nav.push(MessagecenterPage);
    }
    else if(page.component == 'wall') {
        this.nav.push(WallPage);
    }
    else if(page.component == 'login') {
        this.nav.push(LoginPage);
    }
    else if(page.component == 'register') {
        this.nav.push(RegisterRequestPage);
    }
    else if(page.component == 'files') {
        this.nav.push(FilesPage);
    }
    else if(page.component == 'chat_local') {
        this.nav.push(ChatPage);
    }
    else if(page.component == 'webfleet_overview') {
        this.nav.push(WebfleetReportOverviewPage);
    }
    else if(page.component == 'webfleet_list') {
        this.nav.push(WebfleetReportListPage);
    }
    else if(page.component == 'settings') {
        this.nav.push(SettingsPage);
    }
  }

  userMenuAction(action: string) {
      if(action == 'my-profile') {
        this.nav.push(UserInfoPage, {userId: this.userProvider.getUserID()});
      } else if(action == 'my-messages') {
        this.nav.push(MessagecenterPage);
      } else if(action == 'my-settings') {
        this.nav.push(SettingsPage);
      } else if(action == 'my-idcard') {
          this.nav.push(IdcardPage);
      } else if(action == 'contact') {
        this.nav.push(MagazinePage, {title: 'Kontakt', page: Settings.contactPage});
      } else if(action == 'legal') {
        this.nav.push(MagazinePage, {title: 'Impressum', page: Settings.legalPage});
      } else if(action == 'privacy') {
        this.nav.push(MagazinePage, {title: 'Datenschutz', page: Settings.privacyPolicyPage});
      } else if(action == 'logout') {
        this.logoutProvider.logout();
      }
  }

  returnToLogin() {
      this.nav.push(this.rootPage, {checklogin: false});
  }

  loadMenuFromServer() {
      this.http.get(Settings.teamAppApiUrl + '/menu/'+Settings.teamAppApiToken+'.json').subscribe((response) => {
          let menuData = response.json();
          console.log(menuData);

          this.basicPages = menuData.basic;
          this.modulePages = menuData.module;
          this.contentPages = menuData.content;
          this.memberPages = menuData.member;
          this.guestPages = menuData.guest;
          this.footerPages = menuData.footer;
          console.log(menuData.footer);
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts